const getters = {
  addRouters: ({ permission }) => permission.addRouters,
  permission: ({ permission }) => permission.permission,
  permissionList: ({ permission }) => permission.permissionList,
  roles: ({ user }) => user.roles,
  clientdata: ({ user }) => user.clientdata
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js